import { Typography, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import "../../assets/style/SupportTickets.css";
import { useEffect, useState } from "react";

export default function TicketItem({ ticket, onClick }) {
  const { status, subject, messages, created_at, updated_at } = ticket;
  const [currDay, setCurrDay] = useState();
  const [currMonth, setCurrMonth] = useState();

  // Функция для обрезки длинного текста
  const truncateText = (text, maxLength = 30) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // Отладочная информация для проверки структуры тикета
  //console.log('=== TICKET ITEM DEBUG ===');
  //console.log('Full ticket object:', ticket);
  //console.log('Status field:', status);
  //console.log('All ticket fields:', Object.keys(ticket));

  useEffect(() => {
    const getCurrDate = () => {
      const date = new Date(created_at || updated_at || Date.now());
      const day = date.getDate();
      setCurrDay(day);
      const shortMonthName = date.toLocaleString("en-US", { month: "short" });
      setCurrMonth(shortMonthName);
    };

    getCurrDate();
  }, [created_at, updated_at]);

  // Улучшенная логика определения статуса
  const getStatusClass = (status) => {
    //console.log('=== DEBUG STATUS ===');
    //console.log('Original status:', status);
    //console.log('Type of status:', typeof status);
    
    if (!status) {
      //console.log('Status is empty, returning open');
      return 'ticket-status status-open';
    }
    
    const statusLower = status.toLowerCase().trim();
    //console.log('Status lower:', statusLower);
    
    if (statusLower === 'closed' || statusLower === 'close') {
      //console.log('Status is closed, returning closed class');
      return 'ticket-status status-closed';
    }
    
    //console.log('Status is not closed, returning open class');
    return 'ticket-status status-open';
  };

  const statusClassName = getStatusClass(status);
  const displayStatus = status?.toUpperCase() || 'OPEN';
  const dt = new Date(updated_at || created_at);
  
  //console.log('Final status class:', statusClassName);
  //console.log('Display status:', displayStatus);

  return (
    <div className="ticket-item" onClick={onClick}>
      <div className="ticket-main-info">
        <div className="ticket-date">
          <span className="ticket-month">{currMonth}</span>
          <span className="ticket-day">{currDay}</span>
        </div>
        <div className="ticket-summary">
          <div className="summary-header">
            <span className={statusClassName}>{displayStatus}</span>
            <Typography className="ticket-subject">
              {subject && subject !== ticket.ticket_id?.toString() && subject !== ticket.id?.toString() 
                ? truncateText(subject, 25) 
                : `Ticket #${ticket.ticket_id || ticket.id}`}
            </Typography>
          </div>
          <Typography className="ticket-preview">
            {messages && messages.length > 0 ? truncateText(messages[messages.length - 1].content, 35) : 'No messages yet'}
          </Typography>
        </div>
      </div>

      <div className="ticket-meta">
        <Typography className="ticket-last-update">
          <span className="ticket-date-text">
            {dt.toLocaleDateString('en-GB')}
          </span>
                  <span className="ticket-time-text">
            {dt.toLocaleTimeString('en-GB', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })}
          </span>
        </Typography>

        <IconButton className="ticket-view-button" onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}>
          <VisibilityOutlinedIcon />
        </IconButton>
      </div>
    </div>
  );
}
